import { getTipoActivoLabel } from "../constants/clasificacionContable";
import { getNombreProveedor } from "./proveedores";

// ─── Concepto CapEx (ÚNICA fuente, regla 10.1) ───────────────────────────────
// El string que identifica una línea CapEx de activo (edificio) en la UI: el campo
// `razon_social_receptor` de las filas del tab CapEx de Movimientos Futuros y la columna
// "Concepto" del modal Inversión del edificio.
//
// Formato: [edificioNombre, tipoLabel, nombreProveedor, descripcionReal].filter(Boolean).join(" | ")
// El tipo usa getTipoActivoLabel (label bonito "Tótem"/"Costo instalación", MISMA fuente que la
// columna Tipo del modal, regla 10.1) — no MAYÚSCULAS sostenidas.
// El nombre del proveedor sale de getNombreProveedor (alias || razón social, regla 10.1) — requiere
// que el embed de proveedor traiga `alias` (getActivos: proveedor:proveedores(id, nombre, alias)).
//
// El nombre del edificio llega YA RESUELTO (string o null) — el helper NO conoce el
// edificiosMap: quien llama resuelve `edificiosMap[destino_id] || `Edificio #id`` (o null
// si no hay destino) y lo pasa. Función pura, sin efectos ni fetch.

// Descripción "real" de un activo (regla única, 10.1 — reusada por el modal Inversión y por el
// concepto del flujo). Los activos viejos creados por el alta del modal tenían descripcion =
// tipo_activo (basura duplicada); esos se tratan como "sin descripción" → "" (así el concepto no
// muestra el tipo repetido ni deja un "| " colgando, porque el .filter(Boolean) lo descarta).
// Solo devuelve texto si es distinto del tipo y no está vacío.
export const descripcionReal = (activo) =>
  activo?.descripcion && activo.descripcion.trim() && activo.descripcion !== activo.tipo_activo
    ? activo.descripcion
    : "";

export const construirConceptoCapex = (activo, edificioNombre) =>
  [
    edificioNombre,
    getTipoActivoLabel(activo.tipo_activo),
    getNombreProveedor(activo.proveedor),
    descripcionReal(activo),
  ]
    .filter(Boolean)
    .join(" | ");

// ─── Concepto de una línea de LOTE de compra (bloque Stock) ──────────────────
// Fuente ÚNICA (10.1) del string que identifica una línea de lote (FOB + componentes de landed cost)
// en la UI: la columna "Concepto" de la proyección CapEx (mapCapexLote / mapCapexComponente) y el
// tooltip del badge A en Movimientos Históricos. Formato idéntico al que ya usaban los mappers:
// `STOCK {cantidad}x | {TIPO_ACTIVO en mayúsculas} | {proveedor}`.
// Tolera las dos formas del embed del proveedor: `proveedor_rel` (getLotes, columna del lote) o
// `proveedor` embebido como objeto (getCostosLotesPendientes) o como string (columna cruda del lote).
export const construirConceptoLote = (lote) =>
  [
    `STOCK ${lote?.cantidad_total}x`,
    lote?.tipo_activo?.toUpperCase(),
    lote?.proveedor_rel?.nombre ||
      lote?.proveedor?.nombre ||
      (typeof lote?.proveedor === "string" ? lote.proveedor : null),
  ]
    .filter(Boolean)
    .join(" | ");

// Label del tipo de componente de costo de un lote (landed cost). Fuente ÚNICA (10.1). El FOB es la
// base del lote; transporte/aduana/otro son extras que capitalizan aparte.
export const TIPO_COMPONENTE_LABEL = { fob: "FOB", transporte: "Transporte", aduana: "Aduana", otro: "Otro" };
